import { type FC } from 'react';
import CcmDashboardFilterPopover from 'components/molecules/oneplaform/ccm-dashboard-filter-popover';
import { usePodAssignments } from 'infrastructure/hooks/ccm/use-pod-assignments';

import s from './styles.module.scss';
import { PodFilter } from './pod-filter';

import type { TCCMDataFilters } from 'infrastructure/hooks/ccm/console/use-ccm-data-query-filter';
import type { PodFilterValue } from 'infrastructure/interfaces';

interface AccountSelectBoxProps {
  updateFilter: (newFilter: Partial<TCCMDataFilters>) => void;
  clinicGuid?: string[];
  podFilter?: PodFilterValue;
}

export const AccountsSelect: FC<AccountSelectBoxProps> = ({
  clinicGuid,
  updateFilter,
  podFilter,
}) => {
  const { hasPodAssignment, isLoading: podLoading } = usePodAssignments('CCM');

  return (
    <div className={s['select-wrapper-accounts']}>
      <div className={s['select-label']}>
        <CcmDashboardFilterPopover
          useAdminApi
          showOnInteractiveTimeDashboard={false}
          included={clinicGuid}
          middleSlot={
            !podLoading && hasPodAssignment ? (
              <PodFilter value={podFilter} updateFilter={updateFilter} />
            ) : undefined
          }
          onChange={({ included = [] }) => {
            updateFilter({
              'n-clinicGuid': included,
              'n-allExcluded': false,
              'n-page': undefined,
              'f-clinicGuid': included,
              'f-allExcluded': false,
              'f-page': undefined,
              'p-clinicGuid': included,
              'p-allExcluded': false,
              'p-page': undefined,
            });
          }}
        />
      </div>
    </div>
  );
};
